import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { HEADER_BANNER_DELETED } from '../../store/header-banner-actions';
import {
    HEADER_BANNER_LIST_ERROR,
    HEADER_BANNER_LIST_FETCH,
    HEADER_BANNER_LIST_RECEIVE,
} from './header-banner-list-actions';
import { HeaderBannerDto } from '../../models/header-banner-dto';

export interface HeaderBannerListReducerState {
    items: PaginatedResponse<HeaderBannerDto>;
    requesting: boolean;
}

const initialHeaderBannerListReducerState: HeaderBannerListReducerState = {
    items: { limit: 10, page: 0, total: 0, items: [] },
    requesting: false,
};

export const headerBannerListReducer = (
    state: HeaderBannerListReducerState = initialHeaderBannerListReducerState,
    action: AnyAction
): HeaderBannerListReducerState => {
    switch (action.type) {
        case HEADER_BANNER_LIST_FETCH: {
            return {
                ...state,
                requesting: true,
            };
        }

        case HEADER_BANNER_LIST_RECEIVE: {
            return {
                ...state,
                requesting: false,
                items: action['headerBanners'],
            };
        }

        case HEADER_BANNER_LIST_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case HEADER_BANNER_DELETED: {
            return {
                ...state,
                items: {
                    ...state.items,
                    items: state.items.items.filter(item => item.id !== action['id']),
                    total: state.items.total - 1,
                },
            };
        }

        default: {
            return state;
        }
    }
};
